import { render, staticRenderFns } from "./marriageRegister.vue?vue&type=template&id=22b46832&scoped=true&"
import script from "./marriageRegister.vue?vue&type=script&lang=js&"
export * from "./marriageRegister.vue?vue&type=script&lang=js&"
import style0 from "./marriageRegister.vue?vue&type=style&index=0&id=22b46832&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b46832",
  null
  
)

export default component.exports